import { Rocket, ShieldCheck, Users } from "lucide-react"

import { CtaShell } from "./cta-shell"
import type { CtaShellProps } from "./cta-types"

export type TrioCtaProps = CtaShellProps

export function TrioCta(props: TrioCtaProps) {
  return <CtaShell {...props} layout="trio" trio={props.trio ?? [
    { title: "Launch fast", description: "Start with the guided path and publish a stronger first version.", cta: { label: "Start launch", href: "#launch" }, icon: <Rocket className="size-5" /> },
    { title: "Talk strategy", description: "Use a higher-touch path when the business model needs more context.", cta: { label: "Talk to sales", href: "#sales" }, icon: <Users className="size-5" /> },
    { title: "De-risk scope", description: "Compare requirements, proof, and content surfaces before production.", cta: { label: "View checklist", href: "#checklist" }, icon: <ShieldCheck className="size-5" /> },
  ]} />
}
